import BaseService from './base.service'

export default class PedidosService extends BaseService {
    getAll(fnSuccess, fnError) {
        return this.getApi().get(`/pedidos`)
            .then(response => fnSuccess(response))
            .catch(error => fnError(this.getMessageFromError(error)));
    }

    getById(id, fnSuccess, fnError) {
        return this.getApi().get(`/pedidos?id=${id}`)
            .then(response => {
                if (response.data.count === 1)
                    response.data.result = response.data.result[0];
                fnSuccess(response);
            })
            .catch(error => fnError(this.getMessageFromError(error)));
    }

    getByCliente(cliente, fnSuccess, fnError) {
        return this.getApi().get(`/pedidos?cliente=${cliente}`)
            .then(response => fnSuccess(response))
            .catch(error => fnError(this.getMessageFromError(error)));
    }

    getPending(zona, fnSuccess, fnError) {
        return this.getApi().get(`/pedidos?pending&zona=${zona}`)
            .then(response => fnSuccess(response))
            .catch(error => fnError(this.getMessageFromError(error)));
    }

    create(cliente, data, fnSuccess, fnError) {
        return this.getApi().post(`/pedidos?cliente=${cliente}`, data)
            .then(response => fnSuccess(response))
            .catch(error => fnError(this.getMessageFromError(error)));
    }

    getArticulosById(id, fnSuccess, fnError) {
        return this.getApi().get(`/pedidos/articulos?id=${id}`)
            .then(response => fnSuccess(response))
            .catch(error => fnError(this.getMessageFromError(error)));
    }

    changeStatus(id, status, fnSuccess, fnError) {
        return this.getApi().put(`/pedidos/changeStatus?id=${id}&status=${status}`)
            .then(response => fnSuccess(response))
            .catch(error => fnError(this.getMessageFromError(error)));
    }

    changeADespachar(id, renglones, fnSuccess, fnError) {
        return this.getApi().put(`/pedidos/changeADespachar?id=${id}`, renglones)
            .then(response => fnSuccess(response))
            .catch(error => fnError(this.getMessageFromError(error)));
    }

    getPedidosFacturadosSinHoja(fnSuccess, fnError) {
        return this.getApi().get(`/pedidos?facturadosSinHoja`)
            .then(response => fnSuccess(response))
            .catch(error => fnError(this.getMessageFromError(error)));
    }

    getPedidosEntregadosSinHoja(fnSuccess, fnError) {
        return this.getApi().get(`/pedidos?entregadosSinHoja`)
            .then(response => fnSuccess(response))
            .catch(error => fnError(this.getMessageFromError(error)));
    }

    getPDF(id, fnSuccess, fnError) {
        this.getApi()({
            url: '/pedidos/pdf',
            method: 'get',
            params: {
                id: id
            },
            responseType: 'blob'
        })
            .then(response => {
                const file = new Blob(
                    [response.data],
                    {type: 'application/pdf'});
                fnSuccess(file);
            })
            .catch(error => fnError(this.getMessageFromError(error, 'Error al generar el PDF del pedido')));
    }

    getMaxLength(fnSuccess, fnError) {
        return this.getApi().get(`/pedidos/maxLength`)
            .then(response => fnSuccess(response))
            .catch(error => fnError(this.getMessageFromError(error)));
    }
}
